import { unavailablesModel } from "../mappers/models.mapper";
import { SM_QUEUE_SERVER } from "../constants/constants";
import { setNotReady, triggerNotifications } from "../Helpers/helperMessages";
import { Logger } from "../logging/Logger";
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";


export const svrRequestUnavailables = (SDK,  action, notReadyID) => {
    let objectResponse = SDK.apiCont.getObjectResponse();
    SDK.apiCont.getListNoAvailable(SDK.sharedData.getParameters().UserID, objectResponse, SDK.sharedData.requestTimeout);

    objectResponse.onError = function (messageError) {
        const errorCode = action === "getUnavailables" ? 11002 : 11009;
        Logger.Warn(`[AgentSDK] [ResponseFromServer] [Error]-${action}`, messageError);
        triggerNotifications(SDK, MESSAGE_CODE.UNAVAILABLES[errorCode], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
        if (action === "getUnavailables") {
            SDK.errorEvents.errorReceivedUnavailables([]);
        }
    };

    objectResponse.onCatch = function (messageError){
        if (action === "getUnavailables") {
            console.log("catch error consulting getSvrUnavailables in data base----->>", messageError);
            Logger.Warn("catch error consulting getSvrUnavailables in data base----->>", messageError);
        }
    };

    objectResponse.onSuccess = function (objResponse) {
        const hasUnrestricted = objResponse.Response.some(item => item.NotReadyRestricted === 0);
        switch (action) {
            case "getUnavailables":
                    const unavModel = unavailablesModel(objResponse.Response);
                    SDK.svrEvents.onReceivedUnavailables(unavModel);
                    if(hasUnrestricted){
                        triggerNotifications(SDK, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
                    } else {
                        console.log("[AgentSDK] [getUnavailables]: Unavailables restricted by Administrator.");
                        triggerNotifications(SDK, MESSAGE_CODE.UNAVAILABLES[11003], MESSAGE_TYPE.INFO, MESSAGE_FROM.SDK);
                    }
                break;
            case "setUnavailables":
                    if(hasUnrestricted){
                        SDK.sendToRabbit(SM_QUEUE_SERVER, setNotReady(notReadyID));
                        triggerNotifications(SDK, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
                    } else {
                        triggerNotifications(SDK, MESSAGE_CODE.UNAVAILABLES[11004], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
                    }
                break;
            default:
                break;
        }
    };
}

export const setSvrReady = (userName, userID) => {
    const message = {
        action: "ChangeState",
        userName: userName,
        userID: userID,
    };
    return message;
}

export const setSvrReadyWithPassword = (svrResource, agentPass, adminPass, userName, userID) => {
    let objectResponse = svrResource.apiCont.getObjectResponse();
    const ipAddress = svrResource.sharedData.ipAddress;
    const requiredPass = svrResource.state.requiredAdminPass;
    let validationData = messagePassToReady(agentPass, adminPass, requiredPass, userName, ipAddress);
    svrResource.apiCont.validateNotAvailablePassword(validationData, objectResponse);
    objectResponse.onError = function (messageError) {
        console.log("[AgentSDK] [ResponseFromServer] [Error]: "+messageError.Message)
        svrResource.errorEvents.errorReadyWithPassword(messageError.Message);
        triggerNotifications(svrResource, MESSAGE_CODE.UNAVAILABLES[11008].code, MESSAGE_TYPE.ERROR, MESSAGE_FROM.CW, messageError.Message);
        Logger.Warn("[AgentSDK] [ResponseFromServer] [Error] messageError-validateNotAvailablePassword");
    };
    objectResponse.onSuccess = function (objResponse) {
        const agentOk = objResponse.Response.AgentOk;
        const supervisorOk = objResponse.Response.SupervisorOk;
        const respInfo = objResponse.Response.ResponseInformation;
        if(agentOk && (!requiredPass || (requiredPass && supervisorOk))){
            triggerNotifications(svrResource, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
            console.log("[AgentSDK] [SetReadyWithPassword]: Changing Agent status to [Ready].");
            svrResource.setReady();
        } else {
            triggerNotifications(svrResource, MESSAGE_CODE.UNAVAILABLES[11005], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
        }
    };
}

function messagePassToReady(password, supervisorPassword, requieredSupervisorPass, userName, ipAddress) {
    const obj = {
        nombre: userName,
        password: password,
        supervisorPassword: supervisorPassword,
        supervisorPasswordRequired: requieredSupervisorPass,
        ipAddress: ipAddress,
        Sender: 2
    };
    return obj;
}